import React from 'react'
import { observer } from 'mobx-react'
import { UserManagementViewModel } from './UserManagementViewModel'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
} from '../components/StickyViewHeader'
import { useDocumentTitle } from '../hooks/document-title'
import { useScrollOffsetSpring } from '../hooks/spring-hooks'
import { useActivation } from '../hooks/mobx-hooks'
import UserManagementTable from './components/UserManagementTable'
import styles from './UserManagement.sass'
import AccessDeniedView from '../components/AccessDeniedView'

interface UserManagementProps {
  vm: UserManagementViewModel
}

export default observer(({ vm }: UserManagementProps) => {
  useDocumentTitle('User Management')
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  useActivation(vm)

  return vm.canAccessUserManagement ? (
    <div ref={scrollRef} className={styles.root}>
      {/* move to component workspace manager */}
      <StickyViewHeader scrollOffset={scrollOffset}>
        <StickyViewHeaderMain>Workspace Selector!</StickyViewHeaderMain>
        <StickyViewHeaderSpacer />
      </StickyViewHeader>

      {/* table component */}
      <UserManagementTable vm={vm} />
    </div>
  ) : (
    <AccessDeniedView />
  )
})
